var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"dashboard"},[_c('dash-swiper'),_c('dash-goodteaching'),_c('dash-learningeffect'),_c('dash-layered'),_c('dash-research'),_c('dash-highscorelist'),_c('dash-teacher'),_c('dash-joingenius'),_c('dash-evaluation'),_c('dash-aboutfangtian'),_c('dash-question')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }